
export default {
    beforeCreate () {
        // eslint-disable-next-line no-console
        console.log('authenticated:', this.$store.getters.isAuthenticated)
        if (!this.$store.getters.isAuthenticated) {
            this.$router.push({ name: 'login' })
        }
    }
}
